import { render, staticRenderFns } from "./ReimbursementsDetails.vue?vue&type=template&id=80772842&scoped=true"
import script from "./ReimbursementsDetails.vue?vue&type=script&lang=js"
export * from "./ReimbursementsDetails.vue?vue&type=script&lang=js"
import style0 from "./ReimbursementsDetails.vue?vue&type=style&index=0&id=80772842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80772842",
  null
  
)

export default component.exports